
import React from 'react';

//Importar íconos de Material UI.
import { WifiTetheringOff } from '@mui/icons-material/';

// ConnectionFailed : Componente que renderiza la vista en el Inbox cuando falla la conexión del socket.
// Leer en documentación "/docs" información sobre el componente.

const ConnectionFailed = ({ setSocketConnected }) => {

    return (
        <div className="content-unselectedChat--text">
            <WifiTetheringOff sx={{ fontSize: "90px", color: "#96989A" }} />
            <span>No se pudo establecer la conexión</span>
            <button className="btn-reconnection" onClick={() => setSocketConnected(true)}>Conectar</button>
        </div>
    )
};

export default ConnectionFailed;